import React from "react";
import { View, StyleSheet } from "react-native";
import BlackLogoAnimation from "../../assets/BlackLogoAnimation.json";
import WhiteLogoAnimation from "../../assets/WhiteLogoAnimation.json";
import Lottie from "lottie-react";

const LoadingLogo = ({
  width = 75,
  height = 75,
  container = true,
  flex = null,
  marginRight = 0,
  marginLeft = 0,
  marginTop = 0,
  marginBottom = 0,
  dark = false,
}) => {
  return (
    <>
      {container ? (
        <View
          style={[
            styles.container,
            { backgroundColor: colors.backgroundColor },
          ]}
        >
          <Lottie
            animationData={dark ? BlackLogoAnimation : WhiteLogoAnimation}
            loop
            style={{ width: width, height: height, alignSelf: "center" }}
          />
        </View>
      ) : (
        <Lottie
          animationData={dark ? BlackLogoAnimation : WhiteLogoAnimation}
          loop
          style={{
            width: width,
            height: height,
            alignSelf: "center",
            ...(flex != null ? { flex: 1 } : {}),
            marginRight: marginRight,
            marginLeft: marginLeft,
            marginTop: marginTop,
            marginBottom: marginBottom,
          }}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
});

export default LoadingLogo;
